/**
 * Application constants
 */

export const APP_NAME = 'HR Onboarding Portal';
export const APP_VERSION = '1.0.0';

/**
 * Route paths
 */
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  ONBOARDING: '/onboarding',
  OFFBOARDING: '/offboarding',
  EMPLOYEE_UPDATE: '/employee-update',
  HARDWARE_REQUEST: '/hardware-request',
  APPROVAL: '/approval',
  TEAMS: '/teams',
  QUICK_CREATE: '/quick-create',
  ADMIN: '/admin',
  HISTORY: '/history',
  HISTORY_DETAIL: '/history/:requestId',
  AUDIT: '/audit',
  REMOTE_REGISTRY: '/remote-registry',
} as const;

/**
 * Employment types
 */
export const EMPLOYMENT_TYPES = [
  { key: 'Employee', text: 'Employee' },
  { key: 'Contractor', text: 'Contractor' },
] as const;

/**
 * Hardware types
 */
export const HARDWARE_TYPES = [
  { key: 'Laptop', text: 'Laptop' },
  { key: 'Desktop', text: 'Desktop' },
] as const;

/**
 * Hardware request categories
 */
export const MAIN_HARDWARE = [
  'Laptop',
  'Desktop',
  'iPad',
  'Mobile Phone',
] as const;

export const PERIPHERALS = [
  'Docking Station',
  'Mouse',
  'Keyboard',
  'Headset',
  'Printer',
  'Scanner',
  'Camera',
] as const;

export const MONITOR_QUANTITIES = [
  { key: 0, text: 'No monitors' },
  { key: 1, text: '1 Monitor' },
  { key: 2, text: '2 Monitors' },
  { key: 3, text: '3 Monitors' },
] as const;

/**
 * Team visibility options
 */
export const TEAM_VISIBILITY = [
  { key: 'private', text: 'Private' },
  { key: 'public', text: 'Public' },
] as const;

/**
 * Data location options
 */
export const DATA_LOCATIONS = [
  { key: 'NAM', text: 'North America (NAM)' },
  { key: 'CAN', text: 'Canada (CAN)' },
  { key: 'MEX', text: 'Mexico (MEX)' },
  { key: 'EUR', text: 'Europe (EUR)' },
] as const;

/**
 * Request status colors
 */
export const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  pending: { bg: '#fff4ce', text: '#8a6914' },
  approved: { bg: '#dff6dd', text: '#107c10' },
  denied: { bg: '#fde7e9', text: '#a80000' },
  completed: { bg: '#e0f2ff', text: '#0078d4' },
  failed: { bg: '#fde7e9', text: '#a80000' },
};

/**
 * Date format options
 */
export const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

/**
 * Registry hive options
 */
export const REGISTRY_HIVES = [
  { key: 'HKLM', text: 'HKEY_LOCAL_MACHINE' },
  { key: 'HKCU', text: 'HKEY_CURRENT_USER' },
  { key: 'HKCR', text: 'HKEY_CLASSES_ROOT' },
  { key: 'HKU', text: 'HKEY_USERS' },
  { key: 'HKCC', text: 'HKEY_CURRENT_CONFIG' },
] as const;

/**
 * Registry value type options
 */
export const REGISTRY_VALUE_TYPES = [
  { key: 'REG_SZ', text: 'String (REG_SZ)' },
  { key: 'REG_DWORD', text: 'DWORD (32-bit)' },
  { key: 'REG_QWORD', text: 'QWORD (64-bit)' },
  { key: 'REG_EXPAND_SZ', text: 'Expandable String' },
  { key: 'REG_MULTI_SZ', text: 'Multi-String' },
  { key: 'REG_BINARY', text: 'Binary (Base64)' },
] as const;

export const DATETIME_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};
